import styled from "styled-components";

export const AddServiceStyles = styled.div`
  .formHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
